export function SystemMode({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="106"
        height="131"
        viewBox="0 0 106 131"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="selection-ring"
          x="0.828125"
          y="0.828125"
          width="104.344"
          height="129.188"
          rx="14.0781"
          stroke="var(--clr-general-primary)"
          strokeWidth="1.65625"
        />
        <g clipPath="url(#system-mode-card-clip)">
          <rect x="4.14062" y="4.14062" width="48.8594" height="122.562" fill="var(--clr-white)" />
          <rect x="53" y="4.14062" width="48.8594" height="122.562" fill="#14171F" />
        </g>
        <rect
          x="4.96875"
          y="4.96875"
          width="96.0625"
          height="120.906"
          rx="10.7656"
          stroke="#E3E3E3"
          strokeWidth="1.65625"
        />
        <rect
          x="14.0781"
          y="14.0781"
          width="36.4375"
          height="4.96875"
          rx="2.48438"
          fill="#93949E"
        />
        <circle cx="89.4376" cy="16.5621" r="2.65" fill="#93949E" />
        <rect x="12.4219" y="28.9844" width="81.1562" height="1.24219" fill="#93949E" />
        <path
          d="M14.0781 40.9922C14.0781 39.8488 15.005 38.9219 16.1484 38.9219H53V43.0625H16.1484C15.005 43.0625 14.0781 42.1356 14.0781 40.9922Z"
          fill="#93949E"
        />
        <path
          d="M53 38.9219H78.2578C79.4012 38.9219 80.3281 39.8488 80.3281 40.9922C80.3281 42.1356 79.4012 43.0625 78.2578 43.0625H53V38.9219Z"
          fill="#3E404F"
        />
        <path
          d="M53 48.8594H65.0078C66.1512 48.8594 67.0781 49.7863 67.0781 50.9297C67.0781 52.0731 66.1512 53 65.0078 53H53V48.8594Z"
          fill="#3E404F"
        />
        <path
          d="M14.0781 50.9297C14.0781 49.7863 15.005 48.8594 16.1484 48.8594H53V53H16.1484C15.005 53 14.0781 52.0731 14.0781 50.9297Z"
          fill="#93949E"
        />
        <rect
          x="14.0781"
          y="58.7969"
          width="43.0625"
          height="4.14062"
          rx="2.07031"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M53 68.7344H71.6328C72.7762 68.7344 73.7031 69.6613 73.7031 70.8047C73.7031 71.9481 72.7762 72.875 71.6328 72.875H53V68.7344Z"
          fill="#3E404F"
        />
        <path
          d="M14.0781 70.8047C14.0781 69.6613 15.005 68.7344 16.1484 68.7344H53V72.875H16.1484C15.005 72.875 14.0781 71.9481 14.0781 70.8047Z"
          fill="#93949E"
        />
        <path
          d="M53 78.6719H60.0391C61.1825 78.6719 62.1094 79.5988 62.1094 80.7422C62.1094 81.8856 61.1825 82.8125 60.0391 82.8125H53V78.6719Z"
          fill="#3E404F"
        />
        <path
          d="M14.0781 80.7422C14.0781 79.5988 15.005 78.6719 16.1484 78.6719H53V82.8125H16.1484C15.005 82.8125 14.0781 81.8856 14.0781 80.7422Z"
          fill="#93949E"
        />
        <rect
          x="14.0781"
          y="103.516"
          width="77.8438"
          height="13.25"
          rx="6.625"
          fill="var(--clr-general-primary)"
        />
        <defs>
          <clipPath id="system-mode-card-clip">
            <rect x="4.14062" y="4.14062" width="97.7188" height="122.562" rx="11.5938" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}
